import * as React from "react";

import { ordinalColors } from "../../constants/CouncilOrdinals";

interface IProps {
  ordinal: number;
  name: string;
  size?: number;
  x?: number;
  y?: number;
  inverse?: boolean;
}

const border = 3;

const Badge = (props: IProps) => {

  const size = props.size ? props.size : 40;
  const x = props.x ? props.x : 0;
  const y = props.y ? props.y : 0;
  const inverse = props.inverse ? true : false;

  const colors = ordinalColors[props.ordinal];
  const radius = size / 2 - border * 2;
  const primary = props.ordinal === 1;

  const fill   = inverse ? primary ? 'white' : 'transparent' : primary ? colors.primary : 'white';
  const stroke = inverse ? 'white' : colors.primary;
  const text   = inverse ? primary ? '#2FA154' : 'white' : primary ? 'white' : 'black';

  return (
    <svg width={size} height={size} x={x} y={y}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={stroke}
        strokeWidth={border}
        fill={fill}
      />
      <text
        textAnchor="middle"
        x={"50%"}
        y={"65%"}
        stroke={text}
        fill={text}
      >
        {props.name[0]}
      </text>
    </svg>
  );
};

export default Badge;



// WEBPACK FOOTER //
// ./src/components/general/CouncilBadge.tsx